
import { css } from 'lit';
export default css`
@media (min-width: 640px) {.monogram-featured--no-bottom-margin {
      margin-bottom: -130px;
      z-index: -1;
      position: relative
  }
    }
  @media (min-width: 640px) {
  .monogram-featured--layout-builder {
      margin-bottom: initial;
      z-index: initial
  }
    }
  .monogram-featured__wrapper {
  display: flex;
}
  .monogram-featured__wrapper {
  flex-direction: column;
}
  @media (min-width: 640px) {.monogram-featured__wrapper {
    flex-direction: row;
  }
}
  .monogram-featured__image {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
  .monogram-featured__image {
  padding-right: 1.5rem;
}
  .monogram-featured__image {
    min-height: 200px;
    max-height: 280px;
    margin-top: 6rem
  }
  @media (min-width: 640px) {.monogram-featured__image {
    margin-right: 0px;
  }
}
  @media (min-width: 640px) {.monogram-featured__image {
    margin-top: 0px;
  }
}
  @media (min-width: 640px) {.monogram-featured__image {
    max-height: 66%;
  }
}
  @media (min-width: 640px) {.monogram-featured__image {
    padding: 0px;
  }
}
  .monogram-featured__image-wrapper {
  position: relative;
}
  .monogram-featured__image-wrapper {
  z-index: 0;
}
  .monogram-featured__image-wrapper {
  margin-bottom: 1rem;
}
  .monogram-featured__image-wrapper {
  display: flex;
}
  .monogram-featured__image-wrapper {
  align-items: center;
}
  .monogram-featured__image-wrapper {
  align-self: center;
}
  @media (min-width: 640px) {.monogram-featured__image-wrapper {
    margin-top: 0px;
  }
}
  @media (min-width: 640px) {
  .monogram-featured__image-wrapper {
        height: 280px
    }
      }
  @media (min-width: 768px) {
  .monogram-featured__image-wrapper {
        height: 350px
    }
      }
  @media (min-width: 1024px) {
  .monogram-featured__image-wrapper {
        height: 466px
    }
      }
  @media (min-width: 1200px) {
  .monogram-featured__image-wrapper {
        height: 500px
    }
      }
  .monogram-featured__image--before, .monogram-featured__image--after {
  position: absolute;
}
  .monogram-featured__image--before, .monogram-featured__image--after {
  fill: currentColor;
}
  .monogram-featured__image--before, .monogram-featured__image--after {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .monogram-featured__image--before {
  bottom: 0px;
}
  .monogram-featured__image--before {
  z-index: -10;
}
  .monogram-featured__image--before {
      width: 94px;
      right: 105px;
    }
  @media (min-width: 640px) {
  .monogram-featured__image--before {
        right: 80px
    }
      }
  @media (min-width: 768px) {
  .monogram-featured__image--before {
        width: 118px;
        right: 112px
    }
      }
  @media (min-width: 1024px) {
  .monogram-featured__image--before {
        width: 157px;
        right: 144px
    }
      }
  @media (min-width: 1200px) {
  .monogram-featured__image--before {
        width: 168px;
        right: 151px
    }
      }
  .monogram-featured__image--after {
  bottom: 0px;
}
  .monogram-featured__image--after {
  z-index: 10;
}
  .monogram-featured__image--after {
      width: 99px;
      right: -12px;
    }
  @media (min-width: 640px) {
  .monogram-featured__image--after {
        right: -32px
    }
      }
  @media (min-width: 768px) {
  .monogram-featured__image--after {
        width: 126px
    }
      }
  @media (min-width: 1024px) {
  .monogram-featured__image--after {
        width: 165px;
        right: -48px
    }
      }
  @media (min-width: 1200px) {
  .monogram-featured__image--after {
        width: 176px
    }
      }
  .monogram-featured__image--left {
  flex: 1 1 0%;
}
  @media (min-width: 640px) {.monogram-featured__image--left {
    order: 1;
  }
}
  @media (min-width: 640px) {.monogram-featured__image--left {
    margin-right: 3.5rem;
  }
}
  @media (min-width: 640px) {.monogram-featured__image--left {
    justify-content: flex-end;
  }
}
  @media (min-width: 768px) {.monogram-featured__image--left {
    margin-right: 4rem;
  }
}
  @media (min-width: 1024px) {.monogram-featured__image--left {
    margin-right: 5.5rem;
  }
}
  .monogram-featured__image--right {
  flex: 0 1 auto;
}
  @media (min-width: 640px) {.monogram-featured__image--right {
    order: 3;
  }
}
  @media (min-width: 640px) {.monogram-featured__image--right {
    margin-left: 1.5rem;
  }
}
  @media (min-width: 640px) {.monogram-featured__image--right {
    justify-content: flex-start;
  }
}
  @media (min-width: 768px) {.monogram-featured__image--right {
    margin-left: 2rem;
  }
}
  @media (min-width: 1024px) {.monogram-featured__image--right {
    margin-left: 2.5rem;
  }
}
  @media (min-width: 1200px) {.monogram-featured__image--right {
    margin-left: 3rem;
  }
}
  .monogram-featured__image--portrait .monogram-featured__image {
  padding-right: 4rem;
}
  @media (min-width: 640px) {.monogram-featured__image--portrait .monogram-featured__image {
    padding-right: 3rem;
  }
}
  @media (min-width: 768px) {.monogram-featured__image--portrait .monogram-featured__image {
    padding-right: 4.5rem;
  }
}
  @media (min-width: 1024px) {.monogram-featured__image--portrait .monogram-featured__image {
    padding-right: 5rem;
  }
}
  @media (min-width: 1200px) {.monogram-featured__image--portrait .monogram-featured__image {
    padding-right: 6rem;
  }
}
  @media (min-width: 640px) {
  .monogram-featured__image--no-icon {
      max-height: 100%
  }
    }
  .monogram-featured__content {
  order: 2;
}
  .monogram-featured__content {
  display: flex;
}
  .monogram-featured__content {
  flex: 1 1 0%;
}
  .monogram-featured__content {
  flex-direction: column;
}
  .monogram-featured__content {
  justify-content: center;
}
  @media (min-width: 768px) {.monogram-featured__content {
    max-width: 50%;
  }
}
`;